export default "/images/vendor/flag-icons/flags/1x1/ni.svg?ea2b9ff506074adf05ea1d4f8b062c43";